var React = require('react');

function ContentTent (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"content-tent"),React.createElement("path",{"d":"M75.6,72.8,51.8,31.6l2.6-4.5a1.54,1.54,0,1,0-2.7-1.5l-1.7,3-1.7-3a1.54,1.54,0,0,0-2.7,1.5l2.6,4.5-1.5,2.6L24.6,72.3c-.1.1-.1.3-.2.5l-.1.2a1.36,1.36,0,0,0,0,1.5,1.56,1.56,0,0,0,1.3.8H74.3a1.54,1.54,0,0,0,1.5-1.5A1.16,1.16,0,0,0,75.6,72.8ZM58.5,68.5l-4.7-4.7h4.7Zm-.7,3.7H42.3l7.8-7.8ZM41.6,68.5V63.8h4.7Zm6.9-31.2V60.8H40.1a1.54,1.54,0,0,0-1.5,1.5v9.9H28.3ZM61.6,72.2V62.3a1.54,1.54,0,0,0-1.5-1.5H51.6V37.3L71.7,72.2Z","transform":"translate(-24.07 -24.8)","key":1})]);
}

ContentTent.defaultProps = {"role":"presentation","viewBox":"0 0 51.76 50.5"};

module.exports = ContentTent;

ContentTent.default = ContentTent;
